import { Navigate, useRoutes } from "react-router-dom";
import { mainRoutes } from "src/routes/sections/main";
import { homeRoutes } from "src/routes/sections/home";
import { identityRoutes } from "src/routes/sections/identity";

export default function Router() {
  return useRoutes([
    ...homeRoutes,
    ...identityRoutes,
    ...mainRoutes,

    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
